import { render, staticRenderFns } from "./JingleList.vue?vue&type=template&id=48e87270&scoped=true&"
import script from "./JingleList.vue?vue&type=script&lang=js&"
export * from "./JingleList.vue?vue&type=script&lang=js&"
import style0 from "./JingleList.vue?vue&type=style&index=0&id=48e87270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e87270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VVirtualScroll})
